const Notes = (props) => {
  const { notes, setNotes } = props;

  const onClickClose = () => {
    setNotes("");
  };

  return (
    <>
      <div
        className="modal fade add-new-timesheet-modal"
        id="notesModal"
        tabIndex="-1"
        aria-labelledby="notesModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div style={{ maxHeight: "600px" }} className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title font-weight-bold" id="notesModalLabel">
                Notes
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => onClickClose()}
              ></button>
            </div>
            <div className="offcanvas-body">
              <div className="add-new-project-modal">
              {/* <div className="input-flex">
                    <label htmlFor="recipient-name" className="col-form-label">
                      <h6>Temporary project</h6>
                    </label>
                  </div> */}
              {/* <div className="input-flex"> */}
              <h3 className="pt-3">
                {notes ? notes : "No notes found."}
              </h3>
              {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Notes;
